import { Flex, styled } from '@conteg/ui';
import { AuditDashboard } from 'pages/audit/audit-dashboard';
import { ContactView } from 'pages/audit/views/contact-view';
import { ContentView } from 'pages/audit/views/content-view';
import { CourierView } from 'pages/audit/views/courier-view';
import { PointStorageUnitView } from 'pages/audit/views/point-storage-unit-view';
import Login from 'pages/login/login';
import SentSms from 'pages/sent-sms/sent-sms';
import { Route, RouteProps, Routes } from 'react-router-dom';
import { ProtectedRoute } from 'utils/routing/protected-route';

import { RoutePaths } from './route-paths';

const routes: RouteProps[] = [
  { path: '/', element: <Login /> },
  { path: RoutePaths.Login, element: <Login /> },
];

const authRoutes: RouteProps[] = [
  { path: '/', element: <AuditDashboard /> },
  { path: RoutePaths.SentSms, element: <SentSms /> },

  // Audit system routes
  { path: RoutePaths.AuditDashboard, element: <AuditDashboard /> },
  { path: RoutePaths.AuditPoint, element: <PointStorageUnitView /> },
  { path: RoutePaths.AuditContent, element: <ContentView /> },
  { path: RoutePaths.AuditCourier, element: <CourierView /> },
  { path: RoutePaths.AuditContact, element: <ContactView /> },
];

const FlexContainer = styled(Flex)`
  flex-direction: column;
  height: 100%;
  width: 342rem;
  max-width: 100%;
  margin: 0 auto;
`;

const pathName = window.location.pathname;

const Router: React.FC = () => {
  return (
    <FlexContainer>
      <Routes>
        {routes.map((route) => (
          <Route path={route.path} key={route.path} element={route.element} />
        ))}
        <Route>
          {authRoutes.map((route) => (
            <Route
              path={route.path}
              key={route.path}
              element={
                <ProtectedRoute path={`${pathName}${window.location.search}`}>
                  {route.element}
                </ProtectedRoute>
              }
            />
          ))}
        </Route>
      </Routes>
    </FlexContainer>
  );
};

export default Router;
